export const WIZARD_RELEASE_URL = "https://github.com/CoreInfraAI/wizard/releases/latest";
export const WIZARD_PAGE_URL = "https://coreinfra.ru/wizard";
export const WIZARD_DOWNLOADS = [
    {
        id: "macos",
        os: "macOS",
        label: "macOS, Apple Silicon",
        fileName: "CoreInfra-Wizard-darwin-aarch64.dmg",
        requirements: "Apple Silicon (M1 и новее) .dmg",
    },
    {
        id: "macos-intel",
        os: "macOS",
        label: "macOS, Intel",
        fileName: "CoreInfra-Wizard-darwin-x64.dmg",
        requirements: "Mac с процессором Intel .dmg",
    },
    {
        id: "windows",
        os: "Windows",
        label: "Windows, x64",
        fileName: "CoreInfra-Wizard-windows-x64.exe",
        requirements: "Windows x64 .exe",
    },
    {
        id: "windows-arm64",
        os: "Windows",
        label: "Windows, ARM64",
        fileName: "CoreInfra-Wizard-windows-arm64.exe",
        requirements: "Windows ARM64 .exe",
    },
    {
        id: "linux",
        os: "Linux",
        label: "Ubuntu / Debian, x64",
        fileName: "CoreInfra-Wizard-linux-amd64.deb",
        requirements: "Ubuntu / Debian x64 .deb",
    },
].map((download) => ({
    ...download,
    href: `${WIZARD_RELEASE_URL}/download/${download.fileName}`,
}));
// Browser identification can suggest an OS, not reliably determine the CPU
// architecture or Linux distribution. Always show the build requirements.
export function detectWizardPlatform({ userAgent, platform = "", maxTouchPoints = 0, }) {
    const identity = `${userAgent} ${platform}`;
    if (/Android|iPhone|iPad|iPod|Mobile|Windows Phone|CrOS/i.test(identity) ||
        (/Mac/i.test(platform) && maxTouchPoints > 1)) {
        return null;
    }
    if (/Windows|Win32|Win64/i.test(identity)) {
        return /ARM64|aarch64/i.test(identity)
            ? "windows-arm64"
            : /ARM/i.test(identity)
                ? null
                : "windows";
    }
    if (/Macintosh|Mac OS X|MacIntel/i.test(identity))
        return "macos";
    if (/Linux/i.test(identity)) {
        return /ARM|aarch64|i[3-6]86/i.test(identity) ? null : "linux";
    }
    return null;
}
